// extracted by mini-css-extract-plugin
module.exports = {"mulitpleDropdown":"title_mulitpleDropdown__1EIPN","icon":"title_icon__1JLgj","header":"title_header__2MV9s"};